export const getTestId = (text: string): string => {
  return text.trim().toLowerCase().replace(' ', '-');
};
